import { EventType, User } from "@/types";

import { axios } from "../axios.instance";

export type RemoveParticipantRequest = {
  eventId: EventType["id"];
  participantId: User["id"];
};

export type RemoveParticipantResponse = unknown;

export const removeParticipant = async (body: RemoveParticipantRequest): Promise<RemoveParticipantResponse> => {
  const { data } = await axios.post(`/events/manage/${body.eventId}/remove`, { participantId: body.participantId });

  return data;
};
